import { YES_NO } from "./constants"
import type { CategoryField, CategoryFieldOption, CategorySection } from "./types"

export const furnishingOptions: CategoryFieldOption[] = [
  { value: "Unfurnished", label: "Unfurnished" },
  { value: "Semi-Furnished", label: "Semi-Furnished" },
  { value: "Fully-Furnished", label: "Fully-Furnished" },
]

export const CARPET_AREA_INPUT_METHOD_OPTIONS = [
  { value: "By Percentage", label: "By Percentage" },
  { value: "By Absolute Value", label: "By Absolute Value" },
]

export const PARKING_TYPE_OPTIONS = [
  { value: "Basement", label: "Basement" },
  { value: "Podium", label: "Podium" },
  { value: "Open", label: "Open" },
  { value: "Covered", label: "Covered" },
]

export const MAINTENANCE_PAID_OPTIONS: CategoryFieldOption[] = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Shared", label: "Shared" },
]

export const constructionStatusOptions: CategoryFieldOption[] = [
  { value: "Ready to Move", label: "Ready to Move" },
  { value: "Under Construction", label: "Under Construction" },
]

export const configurationOptions: CategoryFieldOption[] = [
  { value: "1 BHK", label: "1 BHK" },
  { value: "2 BHK", label: "2 BHK" },
  { value: "3 BHK", label: "3 BHK" },
  { value: "4 BHK", label: "4 BHK" },
  { value: "5 BHK", label: "5 BHK" },
  { value: "5 BHK+", label: "5 BHK+" },
]

export const waterSupplyOptions: CategoryFieldOption[] = [
  { value: "Municipal Supply", label: "Municipal Supply" },
  { value: "Borewell", label: "Borewell" },
  { value: "Both", label: "Both" },
]

export const powerBackupOptions: CategoryFieldOption[] = [
  { value: "Full", label: "Full" },
  { value: "Partial", label: "Partial" },
  { value: "None", label: "None" },
]

export const mainEntranceDirectionOptions: CategoryFieldOption[] = [
  { value: "North", label: "North" },
  { value: "East", label: "East" },
  { value: "South", label: "South" },
  { value: "West", label: "West" },
  { value: "North-East", label: "North-East" },
  { value: "North-West", label: "North-West" },
  { value: "South-East", label: "South-East" },
  { value: "South-West", label: "South-West" },
]

export const kitchenPlacementOptions: CategoryFieldOption[] = [
  { value: "South-East (Agneya)", label: "South-East (Agneya)" },
  { value: "North-West (Vayavya)", label: "North-West (Vayavya)" },
  { value: "North-East (Ishanya)", label: "North-East (Ishanya)" },
  { value: "South-West (Nairutya)", label: "South-West (Nairutya)" },
  { value: "East", label: "East" },
  { value: "West", label: "West" },
  { value: "North", label: "North" },
  { value: "South", label: "South" },
  { value: "Other", label: "Other" },
]

export const approvalsInPlaceOptions: CategoryFieldOption[] = [
  { value: "Occupancy Certificate", label: "Occupancy Certificate" },
  { value: "Completion Certificate", label: "Completion Certificate" },
  { value: "Fire NOC", label: "Fire NOC" },
]

export const approvalsInPlaceIndustrialOptions: CategoryFieldOption[] = [
  { value: "Industrial Zone Permit", label: "Industrial Zone Permit" },
  { value: "Fire NOC", label: "Fire NOC" },
  { value: "Building Completion Certificate", label: "Building Completion Certificate" },
]

export const occupancyStatusOptions: CategoryFieldOption[] = [
  { value: "Leased / Pre-Rented", label: "Leased / Pre-Rented" },
  { value: "Vacant", label: "Vacant" },
  { value: "Occupied", label: "Occupied" },
  { value: "Partially Occupied", label: "Partially Occupied" },
]

export const tenancyTypeOptions: CategoryFieldOption[] = [
  { value: "Single Tenant", label: "Single Tenant" },
  { value: "Multi-tenanted", label: "Multi-tenanted" },
]

export const truckAccessibilityOptions: CategoryFieldOption[] = [
  { value: "Suitable for 40ft containers", label: "Suitable for 40ft containers" },
  { value: "Suitable for 20ft trucks only", label: "Suitable for 20ft trucks only" },
  { value: "Both 40ft and 20ft", label: "Both 40ft and 20ft" },
  { value: "Small trucks only", label: "Small trucks only" },
  { value: "Other", label: "Other" },
]

export const industrialAreaTypeOptions: CategoryFieldOption[] = [
  { value: "Factory", label: "Factory" },
  { value: "Cold Storage", label: "Cold Storage" },
  { value: "Warehouse", label: "Warehouse" },
  { value: "Other", label: "Other" },
]

export const coldStorageCertificationsOptions: CategoryFieldOption[] = [
  { value: "FSSAI", label: "FSSAI" },
  { value: "HACCP", label: "HACCP" },
  { value: "ISO 22000", label: "ISO 22000" },
  { value: "Other", label: "Other" },
]

export const buildingTypeOptions: CategoryFieldOption[] = [
  { value: "Industrial", label: "Industrial" },
  { value: "Commercial", label: "Commercial" },
  { value: "Retail", label: "Retail" },
  { value: "Other", label: "Other" },
]

export const zoningOptions: CategoryFieldOption[] = [
  { value: "Industrial IT", label: "Industrial IT" },
  { value: "Institutional/Corporate office", label: "Institutional/Corporate office" },
  { value: "Other", label: "Other" },
]

export const primaryRetailCategoryOptions: CategoryFieldOption[] = [
  { value: "Bank", label: "Bank" },
  { value: "QSR", label: "QSR" },
  { value: "Fashion", label: "Fashion" },
  { value: "Electronics", label: "Electronics" },
  { value: "Supermarket", label: "Supermarket" },
  { value: "Jewellery", label: "Jewellery" },
  { value: "Pharmacy", label: "Pharmacy" },
  { value: "Other", label: "Other" },
]

// Land category options
export const plotShapeOptions: CategoryFieldOption[] = [
  { value: "Square (Vargakar)", label: "Square (Vargakar)" },
  { value: "Rectangular (Aayutakar)", label: "Rectangular (Aayutakar)" },
  { value: "Irregular", label: "Irregular" },
  { value: "Other", label: "Other" },
]

export const typeOfSaleOptions: CategoryFieldOption[] = [
  { value: "Direct Sale", label: "Direct Sale" },
  { value: "Joint Venture (JV)", label: "Joint Venture (JV)" },
  { value: "Other", label: "Other" },
]

/** Area units for land plot size (includes Other for free text). */
export const landPlotUnitOptions: CategoryFieldOption[] = [
  { value: "Sq. Ft.", label: "Sq. Ft." },
  { value: "Sq. Yards", label: "Sq. Yards" },
  { value: "Sq. Meters", label: "Sq. Meters" },
  { value: "Acres", label: "Acres" },
  { value: "Bigha", label: "Bigha" },
  { value: "Guntha", label: "Guntha" },
  { value: "Other", label: "Other" },
]

/** Same factors as land, without Other — used with building Plot Area (default Sq. Ft.). */
export const buildingPlotAreaUnitOptions: CategoryFieldOption[] = [
  { value: "Sq. Ft.", label: "Sq. Ft." },
  { value: "Sq. Yards", label: "Sq. Yards" },
  { value: "Sq. Meters", label: "Sq. Meters" },
  { value: "Acres", label: "Acres" },
  { value: "Bigha", label: "Bigha" },
  { value: "Guntha", label: "Guntha" },
]

export const landUseZoneZoningOptions: CategoryFieldOption[] = [
  { value: "Commercial", label: "Commercial" },
  { value: "Industrial", label: "Industrial" },
  { value: "Agricultural", label: "Agricultural" },
  { value: "Institutional", label: "Institutional" },
  { value: "Residential", label: "Residential" },
  { value: "Mixed Use", label: "Mixed Use" },
  { value: "Other", label: "Other" },
]

export const currentSiteConditionOptions: CategoryFieldOption[] = [
  { value: "Vacant & Clear", label: "Vacant & Clear" },
  { value: "Contains Old Structure for Demolition", label: "Contains Old Structure for Demolition" },
  { value: "Partially Developed", label: "Partially Developed" },
  { value: "Other", label: "Other" },
]

export const boundaryWallStatusOptions: CategoryFieldOption[] = [
  { value: "Walled", label: "Walled" },
  { value: "Fenced", label: "Fenced" },
  { value: "Partially Fenced", label: "Partially Fenced" },
  { value: "Open", label: "Open" },
  { value: "Other", label: "Other" },
]

export const utilitiesAvailableOptions: CategoryFieldOption[] = [
  { value: "Electricity Connection", label: "Electricity Connection" },
  { value: "Municipal Water Supply", label: "Municipal Water Supply" },
  { value: "Sewage/Drainage Line", label: "Sewage/Drainage Line" },
  { value: "Borewell", label: "Borewell" },
  { value: "None", label: "None" },
  { value: "Other", label: "Other" },
]

export const plotAndBuildingFields: CategoryField[] = [
  { key: "plotSizeSqYards", type: "number", label: "Plot Size (Sq. Yards)", placeholder: "", tooltip: "Enter the total area of the land plot in Square Yards." },
  { key: "shareOfLandUdsPercent", type: "number", label: "Share of Land UDS (%)", placeholder: "", tooltip: "Crucial: Enter the percentage of the plot's Undivided Share that is allocated to this floor." },
  { key: "totalFloorsInBuilding", type: "number", label: "Total Floors in Building", placeholder: "" },
  { key: "propertyFacingDirection", type: "dropdown", label: "Property Facing Direction", options: mainEntranceDirectionOptions, placeholder: "E.g., North, East, North-East", tooltip: "Select the direction the main plot/building faces." },
  { key: "isCornerPlot", type: "yesno", label: "Is it a Corner Plot?", options: YES_NO },
  { key: "widthOfFrontRoadFt", type: "number", label: "Width of Front Road (ft.)", placeholder: "" },
  { key: "isParkFacing", type: "yesno", label: "Is it Park Facing?", options: YES_NO },
]

export const floorUnitFieldsVacant: CategoryField[] = [
  { key: "floorForSale", type: "yesno", label: "Floor for Sale", options: YES_NO },
  { key: "configuration", type: "dropdown", label: "Configuration", options: configurationOptions, placeholder: "E.g., 3 BHK, 4 BHK, 5 BHK+", tooltip: "Select the unit's configuration." },
  { key: "numberOfBedrooms", type: "number", label: "Number of Bedrooms", placeholder: "" },
  { key: "numberOfBathrooms", type: "number", label: "Number of Bathrooms", placeholder: "" },
  { key: "superBuiltUpArea", type: "number", label: "Super Built-up Area", placeholder: "" },
  { key: "carpetArea", type: "number", label: "Carpet Area", placeholder: "" },
  { key: "furnishingStatus", type: "dropdown", label: "Furnishing Status", options: furnishingOptions },
  { key: "constructionStatus", type: "dropdown", label: "Construction Status", options: constructionStatusOptions, placeholder: "Select status", tooltip: "Select the current status: Ready to Move, Under Construction." },
  { key: "ageOfProperty", type: "number", label: "Age of Property (years)", placeholder: "e.g. 5", tooltip: "How many years old is the building from its completion date?", showWhen: { key: "constructionStatus", value: "Ready to Move" } },
  { key: "possessionDate", type: "text", label: "Possession date", placeholder: "MMM/YYYY e.g. Mar/2025", tooltip: "Enter the expected month and year of possession.", showWhen: { key: "constructionStatus", value: "Under Construction" } },
]

export const floorUnitFieldsPreRented: CategoryField[] = [
  { key: "floorForSale", type: "yesno", label: "Floor for Sale", options: YES_NO },
  { key: "configuration", type: "dropdown", label: "Configuration", options: configurationOptions, placeholder: "E.g., 3 BHK, 4 BHK, 5 BHK+", tooltip: "Select the unit's configuration." },
  { key: "numberOfBedrooms", type: "number", label: "Number of Bedrooms", placeholder: "" },
  { key: "numberOfBathrooms", type: "number", label: "Number of Bathrooms", placeholder: "" },
  { key: "superBuiltUpArea", type: "number", label: "Super Built-up Area", placeholder: "" },
  { key: "carpetArea", type: "number", label: "Carpet Area", placeholder: "" },
  { key: "furnishingStatus", type: "dropdown", label: "Furnishing Status", options: furnishingOptions },
  { key: "ageOfProperty", type: "text", label: "Age of Property", placeholder: "", showWhen: { key: "constructionStatus", value: "Ready to Move" } },
]

export const keyAmenitiesFields: CategoryField[] = [
  { key: "hasLiftAccess", type: "yesno", label: "Has Lift Access?", options: YES_NO },
  { key: "hasModularKitchen", type: "yesno", label: "Has Modular Kitchen?", options: YES_NO },
  { key: "hasServantQuarter", type: "yesno", label: "Has Servant Quarter?", options: YES_NO },
  { key: "isGatedColony", type: "yesno", label: "Is it a Gated Colony?", options: YES_NO },
  { key: "waterSupply", type: "dropdown", label: "Water Supply", options: waterSupplyOptions, placeholder: "E.g., Municipal Supply, Borewell, Both", tooltip: "Select the primary water source." },
  { key: "powerBackup", type: "dropdown", label: "Power Backup", options: powerBackupOptions, placeholder: "E.g., Full, Partial, None", tooltip: "Select the type of power backup available." },
  { key: "isCarParkingIncluded", type: "yesno", label: "Is Car Parking Included?", options: YES_NO },
  { key: "numberOfCarParks", type: "number", label: "Total Number of Car Parks", placeholder: "", showWhen: { key: "isCarParkingIncluded", value: "Yes" } },
]

export const vastuComplianceFields: CategoryField[] = [
  { key: "mainEntranceDirection", type: "dropdown", label: "Main Entrance Direction", options: mainEntranceDirectionOptions, placeholder: "E.g., North, East, North-East", tooltip: "Select the direction the main door of the apartment faces." },
  { key: "kitchenPlacement", type: "dropdown", label: "Kitchen Placement", options: kitchenPlacementOptions, placeholder: "E.g., South-East (Agneya), North-West (Vayavya)", tooltip: "Select the zone where the kitchen is located." },
  { key: "masterBedroomPlacement", type: "dropdown", label: "Master Bedroom Placement", options: kitchenPlacementOptions, placeholder: "E.g., South-West (Nairutya)", tooltip: "Select the zone where the master bedroom is located." },
  { key: "isVastuReportAvailable", type: "yesno", label: "Is a Vastu Report Available?", options: YES_NO },
]

export const amenitiesVastuFields: CategoryField[] = [...keyAmenitiesFields, ...vastuComplianceFields]

export const legalDocFieldsPreRented: CategoryField[] = [
  { key: "titleDeedConveyanceDeed", type: "file", label: "Title Deed / Conveyance Deed", tooltip: "Upload a scanned, clear copy of the property's Title Deed." },
  { key: "leaseAgreement", type: "file", label: "Lease Agreement", tooltip: "Upload a complete, signed copy of the current lease agreement." },
  { key: "latestTaxReceipts", type: "file", label: "Latest Tax Receipts", tooltip: "Upload the most recent property and municipal tax payment receipts." },
  { key: "approvalsInPlace", type: "multiselect", label: "Approvals in Place", options: approvalsInPlaceOptions, tooltip: "Select all applicable approvals: Occupancy Certificate, Completion Certificate." },
]

export const legalDocFieldsVacant: CategoryField[] = [
  { key: "titleDeedConveyanceDeed", type: "file", label: "Title Deed / Conveyance Deed", tooltip: "Upload a scanned, clear copy of the property's Title Deed." },
  { key: "latestTaxReceipts", type: "file", label: "Latest Tax Receipts", tooltip: "Upload the most recent property and municipal tax payment receipts." },
  { key: "approvalsInPlace", type: "multiselect", label: "Approvals in Place", options: approvalsInPlaceOptions, tooltip: "Select all applicable approvals: Occupancy Certificate, Completion Certificate." },
]

export const mediaFields: CategoryField[] = [
  { key: "propertyDescription", type: "richtext", label: "Property Description", tooltip: "Focus on logistical advantages: highway connectivity, port/airport proximity, tenant quality, and building specifications." },
  { key: "propertyImages", type: "file", label: "Property Images", tooltip: "Upload photos of the exterior, loading docks, interior (showing height), and truck access areas." },
  { key: "floorPlan", type: "file", label: "Floor Plan / Site Layout", tooltip: "Upload a clear image or PDF of the site layout, including truck turning radius if possible." },
  { key: "videoTourLink", type: "text", label: "Video Tour Link", placeholder: "https://...", tooltip: "Provide a link to a video walkthrough of the property." },
]

export const genericSections: CategorySection[] = [
  {
    sectionTitle: "Property & occupancy details",
    fields: [
      { key: "occupancyDetails", type: "textarea", label: "Occupancy / Usage details", placeholder: "As per form" },
      { key: "remarks", type: "textarea", label: "Remarks", placeholder: "Any additional notes" },
    ],
  },
]
